var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeIllustratorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.02557H23V22.9743H1V1.02557Z",
    fill: "#261300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V24H24V0H0ZM1 1.02564H23V22.9744H1V1.02564Z",
    fill: "#FF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33045 13.5898L7.54045 16.6667C7.52045 16.7487 7.49045 16.7692 7.39045 16.7692H5.92045C5.82045 16.7692 5.80045 16.7385 5.82045 16.6154L8.66045 6.42053C8.71045 6.23591 8.74045 6.07181 8.76045 5.56925C8.76045 5.49745 8.79045 5.46668 8.84045 5.46668H10.9404C11.0104 5.46668 11.0404 5.4872 11.0604 5.56925L14.2404 16.6359C14.2604 16.718 14.2404 16.7692 14.1604 16.7692H12.5004C12.4204 16.7692 12.3704 16.7487 12.3504 16.6769L11.5204 13.5898H8.33045ZM11.1104 11.9282C10.8304 10.7898 10.1704 8.30771 9.92045 7.10771H9.90045C9.69045 8.30771 9.16045 10.3385 8.74045 11.9282H11.1104ZM15.6104 6.22566C15.6104 5.56925 16.0604 5.1795 16.6304 5.1795C17.2404 5.1795 17.6504 5.60002 17.6504 6.22566C17.6504 6.90258 17.2204 7.27181 16.6104 7.27181C16.0304 7.27181 15.6104 6.90258 15.6104 6.22566ZM15.7304 8.55386C15.7304 8.47181 15.7604 8.43079 15.8504 8.43079H17.4204C17.5004 8.43079 17.5404 8.46156 17.5404 8.55386V16.6462C17.5404 16.7282 17.5204 16.7692 17.4204 16.7692H15.8704C15.7704 16.7692 15.7404 16.718 15.7404 16.6359V8.55386H15.7304Z",
    fill: "#FF7C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeIllustratorIcon);
export default __webpack_public_path__ + "static/media/adobeIllustrator-icon.49631461d5d455724771124ed0829b18.svg";
export { ForwardRef as ReactComponent };